import Img from './logo/genesis-logo.png';
const Logo = () => <img src={Img} alt="logo" />;
const config = {
    title: 'Payments Core Cabinet',
    logo: Logo
};
export default config;
